<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="2"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top">
              <div class="article_con">
                <div class="article_l">
                  <template v-for="(t, index) in tabLeft">
                    <div
                      :class="[
                        'tab_item',
                        currentIndex == index ? 'active' : '',
                      ]"
                      v-if="t.isDisplay == 1"
                      :key="index"
                      @click="handleTab(t, index)"
                    >
                      {{ t.name }}
                    </div>
                  </template>
                </div>

                <div class="article_r">
                  <!-- 下载 -->
                  <div v-if="modelId == '1947910688691474433'">
                    <dataDownLoad
                      :cloumnId="cloumnLeftId"
                      :key="cloumnLeftId"
                    />
                  </div>
                  <!-- 章程 细则 Q&A 入围名单 赛程表 -->
                  <div v-if="modelId == '1868827966551158785'">
                    <chapter :cloumnId="cloumnLeftId" :key="cloumnLeftId" />
                  </div>
                  <!-- 剧目介绍 -->
                  <div v-if="modelId == '1947564739235356674'">
                    <dreamDrama
                      :cloumnLeftId="cloumnLeftId"
                      :cloumnId="cloumnId"
                      :key="cloumnLeftId"
                    />
                  </div>

                  <!-- <div v-if="cloumnLeftId == '1946496336549691394'">
                    <question></question>
                  </div> -->
                  <!-- <div v-if="currentIndex == 1947919153941991425">
                    <Schedule></Schedule>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="isMobile"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <swiper
                :options="swiperOptionOne"
                ref="mySwiperOne"
                class="OneSwiper"
              >
                <swiper-slide class="solon" v-for="(t, x) in tabLeft" :key="x">
                  <div
                    v-if="t.isDisplay == 1"
                    :class="
                      currentIndex == x ? 'active tabList_item' : 'tabList_item'
                    "
                    @click="handleTab(t, x)"
                  >
                    {{ t.name }}
                  </div>
                </swiper-slide>
              </swiper>
              <!-- 下载 -->
              <div v-if="modelId == '1947910688691474433'">
                <dataDownLoad :cloumnId="cloumnLeftId" :key="cloumnLeftId" />
              </div>
              <!-- 章程 细则 Q&A 入围名单 赛程表 -->
              <div v-if="modelId == '1868827966551158785'">
                <chapter :cloumnId="cloumnLeftId" :key="cloumnLeftId" />
              </div>
              <!-- 剧目介绍 -->
              <div v-if="modelId == '1947564739235356674'">
                <dreamDrama
                  :cloumnLeftId="cloumnLeftId"
                  :cloumnId="cloumnId"
                  :key="cloumnLeftId"
                />
              </div>
              <!-- <div v-if="currentIndex == 0"><dataDownLoad /></div>
              <div v-if="currentIndex == 1"><chapter /></div>
              <div v-if="currentIndex == 3">
                <question></question>
              </div>
              <div v-if="currentIndex == 6">
                <Schedule></Schedule>
              </div> -->
            </div>
          </div></AppcontentList
        >
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <AppFooter v-else />
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import AppFooter from '@/components/AppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import question from './component/question.vue';
import dataDownLoad from './component/dataDownLoad.vue';
import chapter from './component/chapter.vue';
import dreamDrama from './component/dreamDrama.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { themeTab, youthCompetiLeft } from '@/const';
export default {
  name: 'YouthCompeti',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    AppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
    question,
    dataDownLoad,
    chapter,
    swiper,
    swiperSlide,
    dreamDrama,
  },
  data() {
    return {
      currentIndex: 0,
      tabList: themeTab,
      cloumnId: null, //栏目id
      tabLeft: [],
      swiperOptionOne: {
        // direction:"horizontal",/*横向滑动*/
        spaceBetween: 0,
        //可见图片张数
        slidesPerView: 4,
        // loopedSlides: 4,// 在loop模式下使用slidesPerView，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)
        loopFillGroupWithBlank: true,
        observer: true, // 改变swiper样式时，自动初始化swiper
        observeParents: true, // 监测swiper父元素，如果有变化则初始化swiper
        autoplayDisableOnInteraction: false,
        paginationClickable: true,
        // 默认选中中间一张
        centeredSlides: false,
        // preventClicks: false,//当swiper在触摸时阻止默认事件（preventDefault），用于防止触摸时触发链接跳转。
        //无限循环
        loop: false,
        on: {
          // click(e) {
          // alert('你点了Swiper');
          // console.log(this, "3333");
          // console.log(e.target.dataset.item, '3333');
          // window.vm.viewTimeTb({
          //   id: e.target.dataset.item,
          // });
          // document.documentElement.scrollTop = 0;
          // },
        },
        //自动轮播
        autoplay: false,
        breakpoints: {
          // 320: {
          //   //当屏幕宽度大于等于320
          //   slidesPerView: 1,
          //   spaceBetween: 0
          // },
          // 776: {
          //   //当屏幕宽度大于等于776
          //   slidesPerView: 2,
          //   spaceBetween: 0
          // },
          // 1000: {
          //   //当屏幕宽度大于等于1000
          //   slidesPerView: 3,
          //   spaceBetween: 0
          // }
        },
        // pagination:'.swiper-pagination',
        //小圆点（我此处没使用，列出供参考）
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'fraction',
          //type : 'custom',
          renderBullet: function (index, className) {
            return '<div class="' + className + '"><span></span></div>';
          },
          // bulletElement: 'li',
        },
        //上下按钮点击轮播效果
        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        },
      },
      id: '',
      cloumnLeftId: null,
      modelId: null,
    };
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      if (this.$route.query.cloumnId) {
        this.cloumnId = this.$route.query.cloumnId;
      }
    }
    this.tabLeft = youthCompetiLeft.filter((c) => c.isDisplay == 1);
    this.tabLeft.map((t, index) => {
      if (this.currentIndex == index) {
        this.cloumnLeftId = t.id;
        this.modelId = t.modelId;
      }
    });
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      // this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    handleTab(t, index) {
      this.currentIndex = index;
      this.cloumnLeftId = t.id;
      this.modelId = t.modelId;
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      padding: 1.25rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .article_l {
        width: 16.6%;

        .tab_item {
          background: #fff;
          margin-bottom: 0.25rem;
          font-size: 1.25rem;
          color: #424451;
          height: 3.75rem;
          line-height: 3.75rem;
          padding-left: 20%;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &.active {
            background: #6b6d7a;
            color: #fff;
            position: relative;
            &::after {
              content: '';
              position: absolute;
              top: 1.625rem;
              right: 1.5rem;
              width: 12px;
              height: 12px;
              background: url('../../assets/img/arrow_color.png') no-repeat;
            }
          }
        }
      }
      .article_r {
        flex: 1;
        margin-left: 2rem;
        background: #fff;
        padding: 1.875rem;
        position: relative;
        h3 {
          font-size: 2.25rem;
          color: #424451;
          text-align: center;
        }
        .down_icon {
          position: absolute;
          right: 1.875rem;
          top: 2.25rem;
        }
        .line {
          width: 100%;
          margin: 0.75rem 0 0;
          height: 0.125rem;
          background: linear-gradient(
            to right,
            rgba(170, 229, 239, 1),
            rgba(177, 187, 255, 1)
          );
        }
        .contact_us {
          font-size: 1.375rem;
          margin: 1.5rem 0;
          font-family: SourceHanSansCN-Medium;
        }
        .contact_item {
          width: 100%;
          font-size: 1.125rem;
          p {
            margin: 1rem 0;
          }
        }
      }
    }
  }
  .app_content_con {
    background: #fff;
  }
  .app_content_top {
    background: #fff;
    margin: 2rem 0;
    .tabList_item {
      height: 1.8333rem;
      line-height: 1.8333rem;
      padding: 0 1rem;
      background: #f0f1f2;
      font-size: 0.8333rem;
      margin-right: 0.9167rem;
      cursor: pointer;
      &.active {
        background: #6b6d7a;
        color: #fff;
      }
    }
  }
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
